import { isPlatformBrowser } from '@angular/common';
import {
 Component,
 OnInit,
 signal,
 Inject,
 PLATFORM_ID,
 inject,
 ChangeDetectorRef,
 afterNextRender,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WebengageService } from '@core/services/webengage.service';
import { NotificationService } from '@shared/components/notification/notification.service';

@Component({
 selector: 'iho-root',
 templateUrl: './app.component.html',
 styleUrls: ['./app.component.scss'],
 providers: [],
})
export class AppComponent implements OnInit {
 title = 'ihowebsite';
 counter = 1;
 notification = inject(NotificationService);
 cdr = inject(ChangeDetectorRef);
 router = inject(ActivatedRoute);
 navigatorVal: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(window.navigator.userAgent)
  : undefined;
 constructor(private webengage: WebengageService, @Inject(PLATFORM_ID) private platformId: Object) {
  afterNextRender(() => {
   window.addEventListener('raychat_ready', function (ets) {
    if (/Android|iPhone/.test(window.navigator.userAgent)) {
     (window as any).Raychat.setStyle({
      width: '0px !important',
      height: '0px !important',
      pointerEvents: 'none',
      shadowBox: '0 0 0 0 white !important',
     });
     (window as any).Raychat.setPosition({
      bottom: '-100%',
      right: '-100%',
     });
    } else {
     (window as any).Raychat.setStyle({
      zIndex: '9 !important',
      borderRadius: '100%',
     });
    }
   });
  });
 }

 CsrStatus = signal(false);

 ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
   window.addEventListener('offline', () => {
    this.notification.warning('آفلاین', 'ارتباط با اینترنت برقرار نیست', 3000);
   });
   window.addEventListener('online', () => {
    this.notification.success('آنلاین', 'ارتباط برقرار شد، لطفا صفحه را مجدد بارگزاری کنید', 3000);
   });
  }
 }
}
